'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var isTypedArray = require('is-typedarray').strict;

var secp256k1 = require('secp256k1');

var sha = require('multihashing-async/src/sha');

var HASH_ALGORITHM = 'sha2-256';

function typedArrayTobuffer(arr) {
  if (isTypedArray(arr)) {
    // To avoid a copy, use the typed array's underlying ArrayBuffer to back new Buffer
    var buf = Buffer.from(arr.buffer);

    if (arr.byteLength !== arr.buffer.byteLength) {
      // Respect the "view", i.e. byteOffset and byteLength, without doing a copy
      buf = buf.slice(arr.byteOffset, arr.byteOffset + arr.byteLength);
    }

    return buf;
  } else {
    // Pass through all other types to `Buffer.from`
    return Buffer.from(arr);
  }
}

module.exports = function (randomBytes) {
  var privateKeyLength = 32;

  function generateKey() {
    var privateKey;

    do {
      privateKey = randomBytes(32);
    } while (!secp256k1.privateKeyVerify(privateKey));

    return privateKey;
  }

  function hashAndSign(_x, _x2) {
    return _hashAndSign.apply(this, arguments);
  }

  function _hashAndSign() {
    _hashAndSign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, msg) {
      var digest, sig;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return sha.digest(msg, HASH_ALGORITHM);

            case 2:
              digest = _context.sent;
              sig = secp256k1.ecdsaSign(digest, key);
              return _context.abrupt("return", typedArrayTobuffer(secp256k1.signatureExport(sig.signature)));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _hashAndSign.apply(this, arguments);
  }

  function hashAndVerify(_x3, _x4, _x5) {
    return _hashAndVerify.apply(this, arguments);
  }

  function _hashAndVerify() {
    _hashAndVerify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, sig, msg) {
      var digest;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return sha.digest(msg, HASH_ALGORITHM);

            case 2:
              digest = _context2.sent;
              sig = typedArrayTobuffer(secp256k1.signatureImport(sig));
              return _context2.abrupt("return", secp256k1.ecdsaVerify(sig, digest, key));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _hashAndVerify.apply(this, arguments);
  }

  function compressPublicKey(key) {
    if (!secp256k1.publicKeyVerify(key)) {
      throw new Error('Invalid public key');
    }

    return typedArrayTobuffer(secp256k1.publicKeyConvert(key, true));
  }

  function decompressPublicKey(key) {
    return typedArrayTobuffer(secp256k1.publicKeyConvert(key, false));
  }

  function validatePrivateKey(key) {
    if (!secp256k1.privateKeyVerify(key)) {
      throw new Error('Invalid private key');
    }
  }

  function validatePublicKey(key) {
    if (!secp256k1.publicKeyVerify(key)) {
      throw new Error('Invalid public key');
    }
  }

  function computePublicKey(privateKey) {
    validatePrivateKey(privateKey);
    return typedArrayTobuffer(secp256k1.publicKeyCreate(privateKey));
  }

  return {
    generateKey: generateKey,
    privateKeyLength: privateKeyLength,
    hashAndSign: hashAndSign,
    hashAndVerify: hashAndVerify,
    compressPublicKey: compressPublicKey,
    decompressPublicKey: decompressPublicKey,
    validatePrivateKey: validatePrivateKey,
    validatePublicKey: validatePublicKey,
    computePublicKey: computePublicKey
  };
};